import React from "react";
import _ from "lodash";
import styled from "styled-components";
import Highchart from "../components/Highchart";

const Wrapper = styled.div`
  padding: 20px 0 0 20px;
  flex-grow: 1;
`;

class QuestionableCalls extends React.Component {
  render() {
    // TODO: There's probably a more functional way to accomplish this, but in the meantime, this will suffice.
    const seriesSuffix = idx =>
      ["QST K 1B", "QST K 3B", "QST B", "QST Count"][idx];
    const seriesAxis = idx => (idx === 3 ? 1 : 0);
    const seriesColor = idx => ["red", "#24CBE5", "green", "black"][idx];

    const series = _.chain(this.props.data.venues)
      .map(venue => {
        const { venue: venueName, venueCalibration } = venue;
        return (
          _.chain(venue.records)
            .map(record => {
              const { shift: x, qstCallResults: qcr } = record;
              return [
                {
                  x,
                  y: qcr.qstStrikeInAutoBallHigh.percent,
                  percent: qcr.qstStrikeInAutoBallHigh
                },
                {
                  x,
                  y: qcr.qstStrikeInAutoBallLow.percent,
                  percent: qcr.qstStrikeInAutoBallLow
                },
                {
                  x,
                  y: qcr.qstBallInAutoStrike.percent,
                  percent: qcr.qstBallInAutoStrike
                },
                { x, y: qcr.qstCalls }
              ];
            })
            // [ [{.1, QST K 1B}, {.1 QST K 3B }], [{.2, QST K 1B}, {.2, QST K 3B}] ]
            .unzip()
            // Transposed 2D array
            // [ [{.1, QST K 1B}, {.2 QST K 1B }], [{.1, QST K 3B}, {.2, QST K 3B}] ]
            .map((seriesData, idx) => {
              return {
                name: `${venueName} [${venueCalibration}]: ${seriesSuffix(
                  idx
                )}`,
                data: seriesData,
                yAxis: seriesAxis(idx),
                marker: {
                  enabled: false
                },
                color: seriesColor(idx),
                tooltip: {
                  pointFormatter: function() {
                    let percentSuffix = "";
                    if (this.percent) {
                      percentSuffix = `
                        <br/>${this.percent.numerator} pitches out of
                        ${this.percent.denominator}`;
                    }

                    return `<span style="color:${this.color}">\u25CF</span>
                      ${this.series.name}: <b>${
                      this.y
                    }</b><br/>${percentSuffix}`;
                  }
                }
              };
            })
            .value()
        );
      })
      .flatten()
      .value();

    const plotLines = _.map(this.props.data.venues, (venue, idx) => {
      const { venue: venueName, venueCalibration, intersectionPt } = venue;
      return {
        color: "#2c2c2c",
        width: 3,
        value: intersectionPt,
        label: {
          text: `${venueName} [${venueCalibration}]: ${intersectionPt}`
        }
      };
    });

    const options = {
      title: {
        text: null
      },
      yAxis: [
        {
          title: {
            text: "Rate"
          }
        },
        {
          title: {
            text: "Count"
          },
          opposite: true
        }
      ],
      xAxis: {
        plotLines: _.concat(
          [
            {
              color: "#f3f3f3",
              width: 2,
              value: 0
            }
          ],
          plotLines
        ),
        title: {
          text: "Offset (ft)"
        }
      },
      legend: {
        layout: "vertical",
        align: "right",
        verticalAlign: "middle"
      },
      plotOptions: {
        series: {
          lineWidth: 2,
          marker: {
            symbol: "circle",
            enabled: true
          }
        }
      },
      series: series
    };

    return (
      <Wrapper>
        <h1>Questionable Calls</h1>
        <Highchart containerId="chart" options={options} />
      </Wrapper>
    );
  }
}

export default QuestionableCalls;



// WEBPACK FOOTER //
// ./src/components/QuestionableCalls.js